import PropTypes from 'prop-types';
import React from 'react';

import Chip from '@/components/AutocompleteBase/Chip';
import UserNameLazy from '@/containers/UserNameLazy';

const CommissarChip = ({ value, ...props }) => (
  <Chip {...props} id={value} label={<UserNameLazy userId={value} />} />
);

CommissarChip.propTypes = {
  onDelete: PropTypes.func.isRequired,
  value: PropTypes.number.isRequired,
};

export default CommissarChip;
